import { get as _get } from 'lodash';

import { ApiStatus, initialApiStatus } from '@amfam/shared/models';

import { CoverageChangeActionsUnion, CoverageChangeActionTypes } from './coverage-change.actions';

export interface State {
  error: ApiStatus | null;
  success: ApiStatus | null;
  loading: boolean;
  cancelNavigationPath: string;
}

export const initialState: State = {
  error: null,
  success: null,
  loading: false,
  cancelNavigationPath: '/policies'
};

export function reducer(state = initialState, action: CoverageChangeActionsUnion): State {
  switch (action.type) {
    case CoverageChangeActionTypes.COVERAGE_CHANGE_REQUEST_NOTIFICATION: {
      return {
        ...state,
        loading: true
      };
    }
    case CoverageChangeActionTypes.COVERAGE_CHANGE_SUCCESS_EMAIL_NOTIFICATION:
    case CoverageChangeActionTypes.COVERAGE_CHANGE_SUCCESS_NOTIFICATION: {
      return {
        ...state,
        success: _get(action, 'payload.status', initialApiStatus),
        error: null,
        loading: false
      };
    }

    case CoverageChangeActionTypes.COVERAGE_CHANGE_QUOTE_REQUEST_FAILURE:
    case CoverageChangeActionTypes.COVERAGE_CHANGE_FAIL_NOTIFICATION: {
      return {
        ...state,
        error: _get(action, 'payload', initialApiStatus),
        success: null,
        loading: false
      };
    }

    case CoverageChangeActionTypes.COVERAGE_CHANGE_FAIL_EMAIL_NOTIFICATION: {
      return {
        ...state,
        error: _get(action, 'payload', initialApiStatus),
        success: null,
        loading: false
      };
    }

    case CoverageChangeActionTypes.COVERAGE_CHANGE_REQUEST_SET_CANCEL_PATH: {
      return {
        ...state,
        cancelNavigationPath: _get(action, 'payload', '')
      };
    }

    case CoverageChangeActionTypes.COVERAGE_CHANGE_REQUEST_RESET_STATE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}

export const getError = (state: State) => state.error;
export const getSuccess = (state: State) => state.success;
export const getLoading = (state: State) => state.loading;
export const getCancelPath = (state: State) => state.cancelNavigationPath;
